<template>
    <div>
        <modal :show.sync="show_modal" :hide-footer="true">
            <h3>Confirmation to return unit: {{ product.product_detail.prod_pm_unit_no }}</h3>
            <b-textarea
            rows="5"
            class="my-3"
            placeholder="Add a reason"
            v-model="return_reason"
            ></b-textarea>
            <div class="my-3">
                <p>By returning the unit, this case will be cancelled and mark as stale. Are you sure?</p>
            </div>
            <div class="d-flex justify-content-center">
                <el-button class="bg-danger text-white" @click="confirmReturn" :loading="is_loading">Yes, I want to return the unit</el-button>
            </div>
        </modal>  
    </div>
</template>
<script>
    import { Button } from 'element-ui'
    import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { useAuthStore } from '@/stores/authStore'
import { mapState, mapActions } from 'pinia'

    export default {
        props:['product'],
        mixins: [notifyFunctionMixin],
        components: {
            [Button.name]: Button,
        },
        data() {
            return {
                is_loading:false,
                show_modal: false,
                return_reason: '',
            }
        },
        watch:{
            product(newVal){
                this.return_reason = ''
            }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user'])
        },
        methods: {
            toggleView() {
                this.show_modal = !this.show_modal;
            },
            confirmReturn(){
                if(this.return_reason === ''){
                    this.errorFunction(null, 'Please add a reason')
                    return
                }

                let type = 'Cancelled'
                if(this.product.prod_main_status === 'Completed'){
                    type = 'Revoke'
                }

                let data = {
                    reason: this.return_reason,
                    type: type,
                    created_by: this.auth_user.id
                }

                this.is_loading = true
                axios.post(services.lookup + 'pmp/cases.im2uv2/'+this.product.prod_id+'/cancel', data, {headers: getHeader()})
                    .then(res => {
                        this.show_modal = false
                        this.is_loading = false
                        caseEventBus.$emit('refresh-cases')
                        this.notifySuccess('<b>Case</b> - Returned Unit Successful.')
                    })
                    .catch(e =>{
                        this.is_loading = false
                        this.errorFunction(e)
                    })
            }
        },
    }
</script>